"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphApiProvider = exports.clearCache = void 0;
var client_1 = require("@apollo/client");
var context_1 = require("@apollo/client/link/context");
var error_1 = require("@apollo/client/link/error");
var aws_appsync_auth_link_1 = require("aws-appsync-auth-link");
var aws_appsync_subscription_link_1 = require("aws-appsync-subscription-link");
var axios_1 = __importDefault(require("axios"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var authenticate_1 = require("./ressources/auth/authenticate");
__exportStar(require("./hooks"), exports);
__exportStar(require("./__generated__/graphql"), exports);
var cache = new client_1.InMemoryCache();
var token;
var clearCache = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, cache.reset()];
            case 1:
                _a.sent();
                token = undefined;
                return [2 /*return*/];
        }
    });
}); };
exports.clearCache = clearCache;
exports.GraphApiProvider = (0, react_1.memo)(function (_a) {
    var children = _a.children, apiEndpoint = _a.apiEndpoint, apiKey = _a.apiKey, apiRegion = _a.apiRegion, authenticateEndpoint = _a.authenticateEndpoint, clientId = _a.clientId, clientSecret = _a.clientSecret, originalAccessToken = _a.accessToken;
    var graphClient = (0, react_1.useMemo)(function () {
        if (!token) {
            return;
        }
        var auth = {
            type: aws_appsync_auth_link_1.AUTH_TYPE.API_KEY,
            apiKey: apiKey,
        };
        var authorizationLink = (0, aws_appsync_auth_link_1.createAuthLink)({
            url: apiEndpoint,
            region: apiRegion,
            auth: auth,
        });
        var subscriptionLink = (0, aws_appsync_subscription_link_1.createSubscriptionHandshakeLink)({
            url: apiEndpoint,
            region: apiRegion,
            auth: auth,
        });
        var authenticationLink = (0, context_1.setContext)(function (_, _a) {
            var headers = _a.headers;
            if (!token) {
                return headers;
            }
            var expires = token.expires, refreshToken = token.refreshToken, accessToken = token.accessToken;
            if ((0, moment_1.default)().isAfter(expires)) {
                return new Promise(function (resolve, reject) {
                    (0, authenticate_1.authenticateWithRefreshToken)(authClient, refreshToken, clientId, clientSecret)
                        .then(function (tokenResponse) {
                        token = {
                            accessToken: tokenResponse.access_token,
                            refreshToken: tokenResponse.refresh_token,
                            expires: (0, moment_1.default)().add(tokenResponse.expires_in, 'seconds'),
                        };
                        resolve({
                            headers: __assign(__assign({}, headers), { authorization: tokenResponse.access_token
                                    ? 'Bearer ' + tokenResponse.access_token
                                    : '' }),
                        });
                    })
                        .catch(function (error) {
                        // No refresh or client token available, we force user to login
                        reject(error);
                    });
                });
            }
            return {
                headers: __assign(__assign({}, headers), { authorization: accessToken ? 'Bearer ' + accessToken : '' }),
            };
        });
        var errorLink = (0, error_1.onError)(function (_a) {
            var graphQLErrors = _a.graphQLErrors, operation = _a.operation, forward = _a.forward;
            if (graphQLErrors && (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.length) > 0) {
                var errorMessage = graphQLErrors[0].message;
                if (errorMessage === 'UNAUTHENTICATED') {
                    if (token) {
                        var expires = token.expires, refreshToken_1 = token.refreshToken, accessToken = token.accessToken;
                        return new client_1.Observable(function (observer) {
                            (0, authenticate_1.authenticateWithRefreshToken)(authClient, refreshToken_1, clientId, clientSecret)
                                .then(function (tokenResponse) {
                                token = {
                                    accessToken: tokenResponse.access_token,
                                    refreshToken: tokenResponse.refresh_token,
                                    expires: (0, moment_1.default)().add(tokenResponse.expires_in, 'seconds'),
                                };
                                operation.setContext(function (_a) {
                                    var _b = _a.headers, headers = _b === void 0 ? {} : _b;
                                    return ({
                                        headers: __assign(__assign({}, headers), { 
                                            // Switch out old access token for new one
                                            authorization: "Bearer ".concat(tokenResponse.access_token) || null }),
                                    });
                                });
                            })
                                .then(function () {
                                var subscriber = {
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                };
                                // Retry last failed request
                                forward(operation).subscribe(subscriber);
                            })
                                .catch(function (error) {
                                // No refresh or client token available, we force user to login
                                observer.error(error);
                            });
                        });
                    }
                }
            }
            return forward(operation);
        });
        return new client_1.ApolloClient({
            link: (0, client_1.from)([authorizationLink, authenticationLink, errorLink, subscriptionLink]),
            cache: cache,
        });
    }, [token]);
    var authClient = (0, react_1.useMemo)(function () {
        return axios_1.default.create({
            baseURL: authenticateEndpoint,
            responseType: 'json',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (!token && originalAccessToken) {
            (0, authenticate_1.authenticateByToken)(authClient, originalAccessToken, clientId, clientSecret)
                .then(function (tokenResponse) {
                token = {
                    accessToken: tokenResponse.access_token,
                    refreshToken: tokenResponse.refresh_token,
                    expires: (0, moment_1.default)().add(tokenResponse.expires_in, 'seconds'),
                };
            })
                .catch(function (_) {
                // ignore
            });
        }
    }, [token, originalAccessToken]);
    if (token === undefined || graphClient === undefined) {
        return react_1.default.createElement(react_1.default.Fragment, null, children(false));
    }
    return (react_1.default.createElement(client_1.ApolloProvider, { client: graphClient }, children((token === null || token === void 0 ? void 0 : token.refreshToken) !== undefined)));
});
